module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cn":{"entertainment_business":"娱乐商务","art_licensing":"艺术授权","art_store":"艺术商店","gallery":"画廊","buy_now":"立即购买","find_out_more":"了解更多"},"en":{"entertainment_business":"Entertainment Endorsement","art_licensing":"Licensing Collaboration","art_store":"Art Store","gallery":"Gallery","buy_now":"Buy Now","find_out_more":"Find out more"}}')
  delete Component.options._Ctor
}
